import { OrderReleasErrorDTO } from "./OrderReleaseErrorDTO";

export class OrderReleaseDTO  {
    errorList: OrderReleasErrorDTO[];
    releasedJobs: String[];
    forcedReleasedJobs: String[];
    responseError: String;
}